import { fromLonLat } from "ol/proj"

export const fromLatLon = (arr: number[]) => {
	return fromLonLat(arr.reverse())
}
